import { Redemption, RedemptionFragment } from '../redemption.types'

export const MultipleCodesRedemptionBlockFragment: RedemptionFragment = {
  name: 'multipleCodesRedemption',
  partialFragment: `
    ...on MultipleCodesRedemption {
      id
      blockType
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const MultipleCodesRedemptionBlockType = 'multipleCodesRedemption'

export interface MultipleCodesRedemptionBlock extends Redemption {
  blockType: typeof MultipleCodesRedemptionBlockType
}
